import { useEffect, useState } from 'react'

const getGreeting = () => {
  const hour = new Date().getHours()

  if (hour < 12) {
    return 'Buenos días'
  }

  if (hour < 20) {
    return 'Buenas tardes'
  }

  return 'Buenas noches'
}

export const useGreetings = () => {
  const [greeting, setGreeting] = useState(getGreeting())

  useEffect(() => {
    // Update greeting every hour
    const interval = setInterval(() => setGreeting(getGreeting()), 1000 * 60 * 60)

    return () => clearInterval(interval)
  }, [])

  return { greeting }
}
